import { lazy } from "react";
import type { Path } from "react-router-dom";
import { generateEncodedPath } from "../../utils/generateEncodedPath";
import type { AppRouteObject } from "../../routes";

export type UserFederationParams = { realm: string };

const UserFederationSection = lazy(() => import("../TenantLogoSection"));

export const TenantLogoRoute: AppRouteObject = {
  path: "/:realm/tenant-logo",
  element: <UserFederationSection />,
  breadcrumb: (t) => t("userFederation"),
  handle: {
    access: "view-realm",
  },
};

export const toTenantLogo = (
  params: UserFederationParams,
): Partial<Path> => ({
  pathname: generateEncodedPath(TenantLogoRoute.path, params),
});
